import { useLocale } from "@/i18n";
import { contactEmail, isContactConfigured } from "@/lib/platform-url";

/**
 * The one place a contact address is rendered.
 *
 * `VITE_CONTACT_EMAIL` is a build-time variable, so a deployment can ship without
 * it. When that happens this renders a visible "not configured" label instead of
 * a `mailto:` pointing at an empty string — a link that looks clickable, opens a
 * blank compose window, and tells the visitor nothing.
 *
 * Every surface that shows the address goes through here so the unconfigured case
 * cannot be handled correctly in one place and forgotten in another.
 */
export function ContactEmail({ className }: { className?: string }) {
  const { t } = useLocale();

  if (!isContactConfigured) {
    return (
      <span className="text-cream-100/40 italic" title="VITE_CONTACT_EMAIL">
        {t.footer.emailUnset}
      </span>
    );
  }

  return (
    <a
      href={`mailto:${contactEmail}`}
      className={
        className ?? "transition-colors hover:text-cream-50"
      }
    >
      {contactEmail}
    </a>
  );
}
